import React from "react";
import Banner from "../Components/Banner";
import { Link } from "react-router-dom";

const Pricing = () => {
  const plans = [
    {
      title: "Website Development",
      text: "Custom, responsive websites built for performance and scalability.",
      price: "PKR 100,000 – 1,500,000+",
      features: [
        "Corporate Websites",
        "E-commerce Platforms",
        "Web Applications",
        "CMS Integration",
      ],
      active: true,
    },
    {
      title: "App Design & Development",
      text: "Cross-platform mobile applications for iOS and Android.",
      price: "PKR 200,000 – 2,000,000+",
      features: [
        "Native & Cross-Platform",
        "API Integration",
        "App Store Deployment",
        "Maintenance",
      ],
      active: false,
    },
    {
      title: "UI/UX Designing",
      text: "User-centric interfaces that drive engagement and conversions.",
      price: "PKR 20,000 – 50,000+",
      features: [
        "Wireframing & Prototyping",
        "User Research",
        "Interactive Design",
        "Brand Consistency",
      ],
      active: false,
    },
    {
      title: "Machine Learning & AI",
      text: "Advanced data models and intelligent automation for your business.",
      price: "PKR 500,000 – 3,000,000+",
      features: [
        "Predictive Analytics",
        "Natural Language Processing",
        "Custom Algorithms",
        "Data Processing",
      ],
      active: true,
    },
    {
      title: "Digital Marketing",
      text: "Strategic campaigns to boost your online visibility and growth.",
      price: "PKR 50,000 – 3,000,000+",
      features: [
        "SEO Optimization",
        "Social Media Management",
        "Paid Advertising (PPC)",
        "Content Strategy",
      ],
      active: false,
    },
  ];

  return (
    <>
      <Banner heading="Pricing Transparency" text="Pricing Transparency" />

      {/* Tpm Our-pricing Area Start */}
      <section className="our-price-plan-area tmp-section-gapBottom z-index-1 mt-5">
        <div className="container">
          <div className="section-head mb--60">
            <div className="section-sub-title center-title tmp-scroll-trigger tmp-fade-in animation-order-1">
              <span className="subtitle">Pricing Plans</span>
            </div>
            <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">
              Transparent Pricing
              <br /> for Custom Solutions
            </h2>
          </div>
          <div className="row align-items-center justify-content-center">
            {plans.map((plan, index) => (
              <div key={index} className="col-lg-4 col-md-6 tmp-scroll-trigger tmp-fade-in mb-5">
                <div className={`price-plan-card border-2 border-[#025383] blur-style-two ${plan.active ? 'active' : ''}`} style={{ height: '100%' }}>
                  <span className="price-sub-title">{plan.title}</span>
                  <h3 className="main-price" style={{ fontSize: '26px' }}>{plan.price}</h3>
                  <p className="per-month">Typical Range</p>

                  <div className="pb-2">
                    <p style={{ color: 'black', fontSize: '15px', lineHeight: '1' }}>{plan.text}</p>
                  </div>

                  <div className="check-box">
                    <ul>
                      {plan.features.map((feature, i) => (
                        <li key={i}>
                          <div className="check-box-item">
                            <div className="box-icon">
                              <i className="fa-solid fa-circle-check" />
                            </div>
                            <p className="box-para">{feature}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="tmp-button-here mt-4">
                    <Link
                      className={`tmp-btn hover-icon-reverse  btn-md radius-round`}
                      to="/contact"
                    >
                      <span className="icon-reverse-wrapper">
                        <span className="btn-text">Request Custom Quote</span>
                        <span className="btn-icon">
                          <i className="fa-sharp fa-regular fa-arrow-right" />
                        </span>
                        <span className="btn-icon">
                          <i className="fa-sharp fa-regular fa-arrow-right" />
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Tpm Our-pricing Area End */}
    </>
  );
};

export default Pricing;